import { Notfound, Signup} from './routes/pages';
import { BrowserRouter, Routes ,Route } from 'react-router-dom';
import Home from './pages/Home';
function App() {
  return (
    <>
    
    <BrowserRouter>
      <Routes>
        <Route path="" element={<Home />} ></Route>
  
        <Route path="/signup" element={<Signup />}></Route>
      
        <Route path="*" element={<Notfound />}></Route>
      </Routes>
      </BrowserRouter>
    </>
  );
}
export default App;